<template>
  <div>
    <div class="bg" v-if="show === 1" @click="showDrop"></div>
    <div class="drop-down" v-if="type === '0'">
      <input @focus="getFocus" @input="sendValue" placeholder="请选择传感器ID搜索" v-model="name"/>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <div class="drop-down-content"  :style=[dropStyle] :class="{'up': show === 1, 'down': show === 0}">
        <div class="drop-down-list" v-for="(data,index) in items" :key="index" @click="sendContent(data,index)" v-if="item && item.length > 0">
          <div class="drop-down-list-item" :class="{'drop-down-list-item-active':name === data.nodeId}">{{data.nodeId}}</div>
        </div>
        <div class="none-data" v-if="item.length === 0">暂无数据</div>
      </div>
    </div>
    <div class="drop-down" v-if="type === '1'">
      <input @focus="getFocus" @input="sendValue" placeholder="请输入人员姓名搜索" v-model="name"/>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <div class="drop-down-content"  :style=[dropStyle] :class="{'up': show === 1, 'down': show === 0}">
        <div class="drop-down-list" v-for="(data,index) in items" :key="index" @click="sendContent(data,index)" v-if="item && item.length > 0">
          <div class="drop-down-list-item" :class="{'drop-down-list-item-active':name === data.name}">{{data.name}}</div>
        </div>
        <div class="none-data" v-if="item.length === 0">暂无数据</div>
      </div>
    </div>
    <div class="drop-down" v-if="type === '2'">
      <input @focus="getFocus" @input="sendValue" placeholder="请输入物料代码搜索" v-model="name"/>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <div class="drop-down-content"  :style=[dropStyle] :class="{'up': show === 1, 'down': show === 0}">
        <div class="drop-down-list" v-for="(data,index) in items" :key="index" @click="sendContent(data,index)" v-if="item && item.length > 0">
          <div class="drop-down-list-item" :class="{'drop-down-list-item-active':name === data.code}" v-if="data.code.length >= 15">
            <el-popover
              placement="top"
              title=""
              trigger="hover"
              :content="data.code">
              <div class="popover" slot="reference">{{data.code}}</div>
            </el-popover>
          </div>
          <div class="drop-down-list-item" v-if="data.code.length < 15" :class="{'drop-down-list-item-active':name === data.code}">{{data.code}}</div>
        </div>
        <div class="none-data" v-if="item.length === 0">暂无数据</div>
      </div>
    </div>
    <div class="drop-down" v-if="type === '3'">
      <input @focus="getFocus" @input="sendValue" placeholder="请输入批次号搜索" v-model="name"/>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <div class="drop-down-content"  :style=[dropStyle] :class="{'up': show === 1, 'down': show === 0}">
        <div class="drop-down-list" v-for="(data,index) in items" :key="index" @click="sendContent(data,index)" v-if="item && item.length > 0">
          <div class="drop-down-list-item" :class="{'drop-down-list-item-active':name === data.batch}" v-if="data.batch.length >= 15">
            <el-popover
              placement="top"
              title=""
              trigger="hover"
              :content="data.batch">
              <div class="popover" slot="reference">{{data.batch}}</div>
            </el-popover>
          </div>
          <div class="drop-down-list-item" v-if="data.batch.length < 15" :class="{'drop-down-list-item-active':name === data.batch}">{{data.batch}}</div>
        </div>
        <div class="none-data" v-if="item.length === 0">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDown',
  data () {
    return {
      canClick: true,
      name: this.content,
      item: this.items,
      show: null,
      up: {
        width: '0'
      },
      iconStyle: {},
      dropStyle: {}
    }
  },
  props: ['content', 'items', 'type'],
  watch: {
    content: function (data) {
      this.name = data
    },
    items: function (data) {
      this.item = data
    }
  },
  methods: {
    sendValue: function (e) {
      this.$emit('sendValue', e.target.value)
    },
    sendContent: function (data) {
      if (this.type === '1') {
        this.name = data.name
      } else if (this.type === '2') {
        this.name = data.code
      } else if (this.type === '3') {
        this.name = data.batch
      } else {
        this.name = data.nodeId
      }
      this.$emit('sendInfo', data)
      this.showDrop()
    },
    getFocus: function () {
      if (this.canClick) {
        this.show = 1
        this.iconStyle.transform = 'rotate(90deg)'
        this.dropStyle = {borderBottom: 'solid 1px #3b79a1'}
      }
    },
    showDrop: function () {
      if (this.canClick) {
        if (this.show === null) {
          this.show = 1
        } else {
          this.show = this.show === 0 ? 1 : 0
        }
        this.iconStyle.transform = this.show === 1 ? 'rotate(90deg)' : 'rotate(0)'
        if (this.show === 1) {
          this.dropStyle = {borderBottom: 'solid 1px #3b79a1'}
        } else {
          this.canClick = false
          let _this = this
          setTimeout(function () {
            _this.dropStyle = {borderBottom: 'none'}
            _this.canClick = true
          }, 500)
        }
      }
    }
  },
  destroyed () {
    this.show = null
  }
}
</script>

<style scoped>
  .drop-down{
    text-align: left;
    width: 13vw;
    height: 2.43vw;
    font-size: 0.83vw;
    color: #00d2ff;
    border: solid 0.05vw #3b79a1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 999;
  }
  .bg{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    top: 0;
    left: 0;
    z-index: 998;
  }
  .drop-down:hover{
    border: solid 0.05vw #00d2ff;
    box-shadow: 0 0 0.2vw #1fb5ac;
    cursor: pointer;
  }
  .icon-font{
    color: #3b79a1;
    position: absolute;
    right: 0.63vw;
    top: 0.68vw;
    margin-right: 0 !important;
    margin-top: 0 !important;
    transition: all .3s ease-in;
  }
  .drop-down:hover > i{
    color: #00d2ff;
  }
  .drop-down-content{
    position: absolute;
    width: 13vw;
    height: 0;
    overflow: auto;
    left: -0.05vw;
    top: 2.38vw;
    background-color: #1d2454;
    border: solid 1px #3b79a1;
    border-top: none;
    border-bottom: none;
    z-index: 8;
    scrollbar-color: transparent transparent;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;
    scrollbar-width:none;
  }
  .drop-down-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  .drop-down-list-item{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding: 0.9vw 0.63vw;
  }
  .drop-down-list-item:hover{
    background: #383f6e;
  }
  .drop-down-list-item-active{
    background: #474e7f;
  }
  .up{
    animation:upSile .5s forwards;
    -moz-animation:upSile .5s forwards; /* Firefox */
    -webkit-animation:upSile .5s forwards; /* Safari and Chrome */
    -o-animation:upSile .5s forwards; /* Opera */
  }
  .down{
    animation:downSile .5s forwards;
    -moz-animation:downSile .5s forwards; /* Firefox */
    -webkit-animation:downSile .5s forwards; /* Safari and Chrome */
    -o-animation:downSile .5s forwards; /* Opera */
  }
  @keyframes upSile {
    from{
      height: 0;
    }
    to{
      height: 9vw;
    }
  }
  @keyframes downSile {
    from{
      height: 300%;
    }
    to{
      height: 0;
    }
  }
  input {
    overflow: hidden;
    padding-right: 2vw;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/DropDownInput.vue